import { createActionGroup, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { StockCheckHistoryListContent, StockCheckHistorySearchCriteria } from '../../model/stock-check-history.model';

export const StockCheckHistoryAction = createActionGroup({
  source: 'Stock Count History',
  events: {
    RequestList: props<{ criteriaObj: StockCheckHistorySearchCriteria }>(),
    ResponseList: props<{
      data: Pagination<StockCheckHistoryListContent>;
    }>()
  }
});
